import { ServiceEventNames, ServiceActionTypes } from '../../shared/utils/ServicesConstants';
import DraftBtn from "../../../../components/servicesButtons/DraftBtn";
import SubmitServiceBtn from "../../../../components/servicesButtons/SubmitServiceBtn";
import SubmitAndPay from "../../../../components/servicesButtons/SubmitAndPay";
import ApproveAndPayLaterBtn from "../../../../components/servicesButtons/ApproveAndPayLaterBtn";
import { eFormButtonsContainer } from "../../../../common/cssclasses";

const IBCActionButtons = ({
    id,
    action,
    eventName,
    serviceId,
    hasFees = false,
    canParticipateWithoutPayment = false,
    reportUrl = null,
    isSentBack = false,
    selectedOwnerId,
    handleCreateEdit
}) => {

    const isDraft = eventName?.toLowerCase() === ServiceEventNames.DRAFT.toLowerCase();
    const isPendingPayment = eventName?.toLowerCase() === ServiceEventNames.PENDING_PAYMENT.toLowerCase();
    const isSentBackEvent = isSentBack || eventName?.toLowerCase() === ServiceEventNames.SENT_BACK.toLowerCase();

    // In VIEW mode, always hide all action and payment buttons
    const isViewMode = action === ServiceActionTypes.VIEW || (Boolean(id) && !isDraft && !isSentBackEvent && !isPendingPayment && action !== ServiceActionTypes.EDIT);

    // Draft button: visible when creating new (!id) OR editing a Draft request (never for SentBack, PendingPayment, or View)
    const showDraftBtn = !isViewMode && (!id || (isDraft && !isSentBackEvent && !isPendingPayment));

    // Submit/Pay button: visible when creating new, editing Draft, editing SentBack, editing mode, OR PendingPayment (never in View mode)
    const showSubmitBtn = !isViewMode && (!id || isDraft || isSentBackEvent || isPendingPayment || action === ServiceActionTypes.EDIT);

    if (!showDraftBtn && !showSubmitBtn) {
        return null;
    }


    return (
        <div className={eFormButtonsContainer}>
            {(
                <>
                    {showDraftBtn && (
                        <DraftBtn onClick={() => handleCreateEdit(ServiceEventNames.DRAFT)} />
                    )}

                    {showSubmitBtn && (
                        hasFees ? (
                            <>
                                {canParticipateWithoutPayment && (
                                    <ApproveAndPayLaterBtn
                                        selectedAccountId={selectedOwnerId}
                                        isApprove={false}
                                        onClick={() => handleCreateEdit(ServiceActionTypes.SUBMIT, false)}
                                    />
                                )}
                                <SubmitAndPay
                                    selectedAccountId={selectedOwnerId}
                                    onClick={() => handleCreateEdit(ServiceActionTypes.SUBMIT, true)}
                                />
                            </>
                        ) : (
                            <SubmitServiceBtn onClick={() => handleCreateEdit(ServiceActionTypes.SUBMIT, false)} />
                        )
                    )}
                </>
            )}
        </div>
    );
};

export default IBCActionButtons;
